import { render } from "./QuizCustomContent.vue?vue&type=template&id=12d01e58&scoped=true"
import script from "./QuizCustomContent.vue?vue&type=script&lang=js"
export * from "./QuizCustomContent.vue?vue&type=script&lang=js"

import "./QuizCustomContent.vue?vue&type=style&index=0&id=12d01e58&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d01e58"]])

export default __exports__